import { render, staticRenderFns } from "./gg-template-table.vue?vue&type=template&id=c5249f24&"
import script from "./gg-template-table.vue?vue&type=script&lang=js&"
export * from "./gg-template-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports